import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.079 6.37506H19.8265V3.12502C19.7847 2.50001 19.2838 2 18.6993 2H3.1272C2.50098 2 2 2.50001 2 3.12502V14.4584C2 15.0834 2.50098 15.5834 3.1272 15.5834H11.7272V21.0417C11.7272 21.5834 12.1864 22 12.6873 22H21.0368C21.5796 22 21.997 21.5417 21.997 21.0417L21.9971 7.33329C22.0389 6.79171 21.6214 6.37499 21.0788 6.37499L21.079 6.37506ZM10.0156 14.5834C9.80693 14.5834 9.63989 14.4167 9.63989 14.2084C9.63989 14.0001 9.80693 13.8334 10.0156 13.8334H11.6856V14.5417L10.0156 14.5418V14.5834ZM11.7272 7.33329V12.9584H3.503V3.50002H18.3237V6.37506H12.6877C12.1449 6.37506 11.7274 6.79178 11.7274 7.33336L11.7272 7.33329ZM17.7808 7.37501C17.7808 7.54172 17.6138 7.7083 17.4469 7.7083H16.3197C16.1527 7.7083 15.9858 7.54158 15.9858 7.37501C15.9858 7.20829 16.1528 7.04171 16.3197 7.04171H17.4469C17.6138 7.08329 17.7808 7.20829 17.7808 7.37501ZM16.8623 21.2502C16.4448 21.2502 16.1527 20.9169 16.1527 20.5419C16.1527 20.1252 16.4866 19.8336 16.8623 19.8336C17.2799 19.8336 17.572 20.1669 17.572 20.5419C17.6138 20.9169 17.2799 21.2502 16.8623 21.2502ZM20.7449 19.0835H13.0216V8.3333H20.7449V19.0835Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgResponsiveOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgResponsiveOutline;
